import { Grid } from "@material-ui/core";
import { Button } from "@mui/material";

const TabButtons = ({ userType, activeTab, onTabClick }) => (
  <Grid item style={{ display: "flex", gap: "8px" }}>
    {userType !== "RETAILER" && (
      <Button
        onClick={() => onTabClick("DEBIT")}
        sx={{
          textTransform: "none",
          backgroundColor: activeTab === "DEBIT" ? "red" : "gray",
          color: "white",
          borderRadius: "10px",
          padding: "8px 16px",
          fontFamily: "sans-serif",
          fontSize: { xs: "12px", md: "14px" },
        }}
      >
        Debit
      </Button>
    )}
    {userType!=="ADMIN" && (
    <Button
      onClick={() => onTabClick("CREDIT")}
      sx={{
        textTransform: "none",
        backgroundColor: activeTab === "CREDIT" ? "green" : "gray",
        color: "white",
        borderRadius: "10px",
        padding: "8px 16px",
        fontFamily: "sans-serif",
        fontSize: { xs: "12px", md: "14px" },
      }}
    >
      Credit
    </Button>
    )}
  </Grid>
);

export default TabButtons;
